import React, { useEffect, useState } from "react";
import axios from "../../../../../axios";
import { IP } from "../../../../../internalServer";
import assets from "../../../../../assets/assets";
// css comes in published_hw.css

const LikePopUp = ({ post, likedRes, isOpen, setIsOpen, isReply }) => {

  const [profilePictureUrls, setProfilePictureUrls] = useState([]);

  useEffect(() => {
    // Update profile picture URLs when the component mounts
    const updatedProfilePictureUrls = post.likes.map((like) =>
      helper(like?.profilePicture || like?.profile_picture)
    );
    setProfilePictureUrls(updatedProfilePictureUrls);
  }, [post.likes]);

  const helper = (a) => {
    if (a) {
      const startsWithDot = a.startsWith(".");
      if (startsWithDot) {
        return IP + a.substring(1); // Remove the leading dot before concatenating with IP
      } else {
        return a;
      }
    }
    return ""; // Return an empty string if the URL is not provided
  };

  return (
    <>
      <div className=" mt-2 p-0 student_list_box1 ">
        <div className=" student_list_header_colour1"></div>
        <div
          className="px-2 mt-2 d-flex align-items-center justify-content-between student_list_header_box"
          id={post.likes.length}
        >
          <span>{`${isReply ? "Reply" : "Post"}`} liked by</span>
          <img
            src={assets.closeIcon}
            alt=""
            height={"20px"}
            width={"20px"}
            className="object-contain"
            style={{ cursor: "pointer" }}
            onClick={() => setIsOpen(false)}
          />
        </div>
        <div className="mx-2 mt-1 completed_student_count">
          Total {post.likes.length} {post.likes.length === 1 ? "user" : "users"}
        </div>
        <div
          className="p-2 mt-1 mx-2 completed_name_list_box "
          id={post.likes.length}
        >
          {
            // profilePictureUrls.map((url, index) => (
            //   <div className="mb-2 gap-2 d-flex align-items-center  " key={index}>
            //     <img src={url} className="ppStyl" alt="" />
            //     <span className=" completed_s_name_list">
            //       {post.likes[index]?.name}
            //     </span>
            //   </div>
            // ))
          }
          {post.likes.map((like, index) => (
            <div className="mb-2 gap-2 d-flex align-items-center" key={index}>
              {like?.userType === "Teacher" ? (
                <img
                  src={
                    like?.profile_picture
                      ? IP + like?.profile_picture.replace(/^\./, "")
                      : like?.gender === "M"
                        ? "/images/Teacher_Male.jpg"
                        : like?.gender === "F"
                          ? "/images/Teacher_Female.png"
                          : "/images/default image.png"
                  }
                  alt="icon"
                  className=""
                  style={{
                    width: "25px",
                    height: "25px",
                    borderRadius: "50%",
                    cursor: "pointer",
                  }}
                  key={like?.avatarProfile}
                  onError={(e) => {
                    if (like?.gender === "M") {
                      e.target.src = "/images/Teacher_Male.jpg";
                    } else if (like?.gender === "F") {
                      e.target.src = "/images/Teacher_Female.png";
                    } else {
                      e.target.src = "/images/default image.png";
                    }
                  }}
                />
              ) : (
                <img
                  src={
                    like?.profile_picture
                      ? IP + like?.profile_picture.replace(/^\./, "")
                      : like.gender === "M"
                        ? like?.avatarProfile
                          ? "/images/Boys/" + like?.avatarProfile + ".webp"
                          : "/images/Student_boy_pic.png"
                        : like?.gender === "F"
                          ? like?.avatarProfile
                            ? "/images/Girls/" + like?.avatarProfile + ".webp"
                            : "/images/Student_girl_pic.png"
                          : "/images/default image.png"
                  }
                  alt="icon"
                  className=""
                  style={{
                    width: "25px",
                    height: "25px",
                    borderRadius: "50%",
                    cursor: "pointer",
                  }}
                  key={like?.avatarProfile}
                  onError={(e) => {
                    if (like?.gender === "M") {
                      e.target.src = like?.avatarProfile
                        ? "/images/Boys/" + like?.avatarProfile + ".webp"
                        : "/images/Student_boy_pic.png";
                    } else if (like?.gender === "F") {
                      e.target.src = like?.avatarProfile
                        ? "/images/Girls/" + like?.avatarProfile + ".webp"
                        : "/images/Student_girl_pic.png";
                    } else {
                      e.target.src = "/images/default image.png";
                    }
                  }}
                />
              )}
              <span className="completed_s_name_list">{like?.name}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default LikePopUp;
